export default __webpack_public_path__ + "static/media/articleImgOne.d669d03c.png";